import { render, staticRenderFns } from "./GiftLogin.vue?vue&type=template&id=55b002fc&scoped=true"
import script from "./GiftLogin.vue?vue&type=script&lang=js"
export * from "./GiftLogin.vue?vue&type=script&lang=js"
import style0 from "./GiftLogin.vue?vue&type=style&index=0&id=55b002fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b002fc",
  null
  
)

export default component.exports